import Render from '@Views/components/input/dropdown-editable-indicator/open-indicator.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class OpenIndicator extends Vue {}